import { Alert, Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";

const GraphQL: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <h1>
        <a href='https://graphql.org/'>GraphQL</a>
      </h1>
      <p className='text-justify'>
        GraphQL es un lenguaje de consulta de datos diseñado internamente por
        Facebook en el año 2015. Como todo lenguaje, GraphQL se define a partir
        de un estándar, lo que significa que para usar GraphQL hay que utilizar
        una librería que implemente el estandar para realizar dichas consultas,
        o implementar el estandar por nuestra cuenta. Claramente, la segunda
        opción no tiene sentido, así que en Crombie utilizamos distintas
        librerías (dependiendo el entorno en el que se ejecute el sistema a
        desarrollar) para realizar consultas GraphQL.
      </p>
      <h2>
        <a href='https://www.apollographql.com/'>Apollo</a>
      </h2>
      <p className='text-justify'>
        En Crombie, cuando necesitamos establecer comunicaciones con servidores
        que operen con GraphQL usamos Apollo. Apollo es la implementación de
        GraphQL más usada en entornos de desarrollo web actualmente. En
        particular, nosotros usamos{" "}
        <a href='https://www.apollographql.com/docs/react/get-started/'>
          Apollo Client
        </a>{" "}
        para realizar las consultas desde el front-end o la aplicación
        react-native.{" "}
      </p>
      <Alert variant='warning'>
        Si bien la librería Apollo Client tiene métodos especificos para React,
        la misma se puede usar en cualquier front-end manejado por JavaScript
      </Alert>
    </Container>
  );
};

export default new Content({
  Component: GraphQL,
  title: "GraphQL",
  route: "graphql",
  tags: [
    "query",
    "backend",
    "facebook",
    "graph",
    "apollo",
    "apollo-server",
    "apollo-client"
  ]
});
